import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect } from 'react';
import { shape } from 'prop-types';
import CouponCodeCopy from '@magalu/stereo-ui/molecules/CouponCodeCopy';
import { useInView } from 'react-intersection-observer';
import { usePublisher } from '@magalu/mixer-publisher';
import { formattedDate } from './utils';
import { Container } from './ProductCoupon.styles';
var ProductCoupon = function ProductCoupon(_ref) {
  var _product$seller, _product$seller$tags;
  var staticProps = _ref["static"],
    structure = _ref.structure;
  var _usePublisher = usePublisher(),
    publish = _usePublisher.publish;
  var product = staticProps.product;
  var coupon = product == null ? void 0 : (_product$seller = product.seller) == null ? void 0 : (_product$seller$tags = _product$seller.tags) == null ? void 0 : _product$seller$tags.find(function (tag) {
    return (tag == null ? void 0 : tag.type) === 'coupon';
  });
  if (!coupon) return null;
  var code = coupon.code,
    discountType = coupon.discountType,
    discountValue = coupon.discountValue,
    endDate = coupon.endDate,
    message = coupon.message;
  var useInViewConfig = {
    threshold: 0.5,
    triggerOnce: true
  };
  var handleView = function handleView() {
    publish('coupon:viewItem', {
      couponName: code,
      screenName: structure == null ? void 0 : structure.name,
      sectionTitle: message
    });
  };
  var handleClick = function handleClick() {
    publish('coupon:selectItem', {
      couponName: code,
      screenName: structure == null ? void 0 : structure.name,
      sectionTitle: message
    });
  };
  var _useInView = useInView(useInViewConfig),
    _useInView2 = _slicedToArray(_useInView, 2),
    ref = _useInView2[0],
    inView = _useInView2[1];
  useEffect(function () {
    if (inView && coupon) {
      handleView();
    }
  }, [inView]);
  return React.createElement(Container, {
    ref: ref
  }, React.createElement(CouponCodeCopy, {
    code: code.toUpperCase(),
    discountType: discountType,
    discountValue: discountValue,
    expirationDate: formattedDate(endDate),
    auxiliaryText: "Copie o cupom e cole na revis\xE3o. V\xE1lido at\xE9",
    onCopySuccess: handleClick
  }));
};
process.env.NODE_ENV !== "production" ? ProductCoupon.propTypes = {
  "static": shape({}),
  structure: shape({})
} : void 0;
ProductCoupon.defaultProps = {
  "static": {},
  structure: {}
};
ProductCoupon.ssr = false;
ProductCoupon.displayName = 'ProductCoupon';
export default ProductCoupon;